import {
  type PosthogExceptionEntry,
  exceptionValue,
} from "./posthog-exception-types";

export const FACEBOOK_IAB_BRIDGE_FUNCTIONS = [
  "setContactAutofillValuesFromBridge",
  "getContactAutofillValuesFromBridge",
];

export function isFacebookIabBridgeException(
  first: PosthogExceptionEntry,
): boolean {
  const frames = first.stacktrace?.frames ?? [];
  return frames.some((frame) => {
    const candidates = [
      frame.function,
      frame.mangled_name,
      frame.resolved_name,
    ];
    return candidates.some((name) => {
      if (!name) return false;
      return FACEBOOK_IAB_BRIDGE_FUNCTIONS.some((needle) =>
        name.includes(needle),
      );
    });
  });
}

const FACEBOOK_ANDROID_PERF_LOGGER_FILENAME =
  "navigation_performance_logger_android";

const FACEBOOK_ANDROID_PERF_LOGGER_VALUE_FRAGMENT =
  "Error invoking postMessage";

function frameIsFacebookAndroidPerfLogger(frame: {
  filename?: string;
  abs_path?: string;
}): boolean {
  const file = frame.filename ?? frame.abs_path ?? "";
  return file.includes(FACEBOOK_ANDROID_PERF_LOGGER_FILENAME);
}

function exceptionIsFacebookAndroidPerfLogger(
  value: string,
  frames: Array<{ filename?: string; abs_path?: string }>,
): boolean {
  if (!value.includes(FACEBOOK_ANDROID_PERF_LOGGER_VALUE_FRAGMENT))
    return false;
  if (frames.length === 0) return false;
  return frames.some(frameIsFacebookAndroidPerfLogger);
}

export function isFacebookAndroidPerfLoggerNoise(
  entries: Array<PosthogExceptionEntry>,
): boolean {
  if (entries.length === 0) return false;
  return entries.every((entry) =>
    exceptionIsFacebookAndroidPerfLogger(
      exceptionValue(entry),
      entry.stacktrace?.frames ?? [],
    ),
  );
}
